export default __webpack_public_path__ + "static/media/Marathi_dm_2.ca6af44b.mp3";